// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cognito_identity_pool_id': 'us-east-1:fc7cdc1c-7d39-4977-9cc5-bf29fbe73217',
    'aws_cognito_region': 'us-east-1',
    //'aws_mobile_analytics_app_id': '7c81c07abdaa407899194145c0ba1ddc',
    //'aws_mobile_analytics_app_region': 'us-east-1',
    //'aws_project_id': '608be04a-e477-4008-8f53-0c04e43590d2',
    //'aws_project_name': 'deliverydev',
    'aws_project_region': 'us-east-1',
    //'aws_resource_name_prefix': 'deliverydev',
    'aws_sign_in_enabled': 'enable',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-1_vE1iLbwgW',
    'aws_user_pools_mfa_type': 'OFF',
    'aws_user_pools_web_client_id': '10omi1las4ufhcoumkddqlu6i1',
}

export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js